import React, { FC } from 'react';

import NextLink, { LinkProps as NextLinkProps } from 'next/link';

import { getLink, KnownRoutes } from '@utils/route';

type LinkProps = {
    route: KnownRoutes | string;
    target?: string;
    title?: string;
    className?: string;
    rel?: string;
    'data-testid'?: string;
} & Omit<NextLinkProps, 'href'>;

export const Link: FC<LinkProps> = (props) => {
    const { target, children, route, ...otherProps } = props;

    return (
        <NextLink href={getLink(route)}>
            <a target={target} {...otherProps}>
                {children}
            </a>
        </NextLink>
    );
};
